import { connect } from 'react-redux';
import { actions } from '../../../../redux/modules/recursos_humanos/descuentoHora';
import Falta from './DescuentoHora';


const ms2p = (state) => {
  return {
    ...state.descuento_hora_rh,
  };
};

const md2p = { ...actions };

export default connect(ms2p, md2p)(Falta);